module.exports = __webpack_public_path__ + "static/media/uj_munkatars2.0644a5ce.jpg";